<!--En caso de no poder cargar los datos se muestro aquí la información pertinente-->
<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE PRODUCTOS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <!--matSortActive="id" matSortDirection="asc"-->
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="clientName" *ngIf="userData.pro_id == 4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.clientName}} </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha alta </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{formatDateTime(element.created_at)}} </td>
            </ng-container>

            <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Modificado </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{formatDateTime(element.updated_at)}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver producto" class="amarillo" aria-label="Ver producto" routerLink="/cerveza/{{element.id}}">
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                    <button *ngIf="userData.pro_id == 4 || userData.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar producto" class="amarillo"
                    aria-label="Editar producto" routerLink="{{element.id}}/editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[20,40,80]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="custom1">
        </mat-paginator>
    </div>
</ng-container>

